import type { Permission as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';
import * as PermissionOption from './PermissionOption';

/**
 * A single permission row inside a group: the level the role currently holds, plus the levels it
 * could be set to. `level` and the option values are free-form strings on the schema (`none` /
 * `read` / `edit` today), not an enum.
 */
export type Permission = {
  icon?: string;
  key: string;
  label: string;
  level: string;
  options: PermissionOption.PermissionOption[];
};

// `icon` is nullable on the schema and `take()` drops only `undefined`, so normalise it rather
// than let a `null` through a field the type declares as `string | undefined`.
export const fromGql = (item: GQLItem): Permission => ({
  ...take<Omit<Permission, 'icon' | 'options'>>(item, 'key', 'label', 'level'),
  icon: item.icon ?? undefined,
  options: item.options?.map(PermissionOption.fromGql) ?? [],
});
